import styled, { css } from 'styled-components';

import { ColorName } from 'types';

import { pickColor } from 'themes/helpers/pickColor';

import { Button } from 'components/Button';

type StyledBarProps = {
  color: ColorName;
};

type GroupItemProps = {
  hasBorder?: boolean;
};

const Bar = styled.nav<StyledBarProps>`
  height: ${({ theme }) => theme.settingsBarHeight};

  position: sticky;
  top: 0;

  z-index: 11;
  background-color: ${({ color }) => pickColor(color)};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 100%;
`;

const SettingsButton = styled(Button)`
  height: 100%;
  min-width: 9.5rem;
  padding: 0 1rem;
  justify-content: flex-start;
`;

const Group = styled.ul`
  display: flex;

  height: 100%;
`;

const GroupItem = styled.li<GroupItemProps>`
  position: relative;

  border-left: ${({ hasBorder }) =>
    hasBorder ? css`0.1rem solid ${pickColor('white')}` : 'none'};
`;

export { Bar, Group, GroupItem, SettingsButton, Wrapper };
